import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { connect } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SettingsIcon from '@material-ui/icons/Settings';

import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import CastIcon from '@material-ui/icons/Cast';
import BusinessIcon from '@material-ui/icons/Business';
import DevicesIcon from '@material-ui/icons/Devices';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ReceiptIcon from '@material-ui/icons/Receipt';

//import { Profile, SidebarNav, UpgradePlan } from './components';
import { Profile, SidebarNav } from './components';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { isDesktop, onClickLogout, open, variant, onClose, className, ...rest } = props;

  const { categories } = props;

  const classes = useStyles();

  const [pages, setPages] = useState([]);

  useEffect(() => {
    //console.log('componentDidUpdate & categoryChecks changed');

    let userId = '';
    let role = '';
    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        userId = decoded.userid;
      }
      if (decoded.role !== null) {
        role = decoded.role;
      }
    }

    const categoryPages = [];
    if (role === 'admin' || role === 'user') {
      categoryPages.push({
        title: '플레이어',
        href: '/advertise/player',
      });
      categoryPages.push({
        title: '지역DB',
        href: '/advertise/addressdb',
      });
      categories.map((category) => {
        const newSubPage = {
          title: category.name,
          href: `/advertise/${category.template}/${category.name}`,
        };
        categoryPages.push(newSubPage);
      });

      setPages(
        [
          {
            title: '메인화면',
            href: '/main',
            icon: <DashboardIcon />,
          },
          {
            title: '광고관리',
            href: '/category',
            icon: <OndemandVideoIcon />,
            submenus: [...categoryPages]
          },
          {
            title: '캠페인관리',
            href: '/campaign',
            icon: <CastIcon />,
          },
          {
            title: '업체&광고사',
            href: '/company/distributor',
            icon: <BusinessIcon />,
            submenus: [
              {
                title: '대리점관리',
                href: '/company/distributor',
              },
              {
                title: '택시회사관리',
                href: '/company/taxi',
              },
              {
                title: '차량관리',
                href: '/company/cars',
              },
              {
                title: '광고대행사관리',
                href: '/company/agency',
              },
              {
                title: '광고주관리',
                href: '/company/client',
              }
            ]
          },
          {
            title: '디바이스',
            href: '/device/manage',
            icon: <DevicesIcon />,
            submenus: [
              {
                title: '디바이스관리',
                href: '/device/manage',
              },
              {
                title: '디바이스로그',
                href: '/device/logs',
              },
              {
                title: '디바이스장애현황',
                href: '/device/errors',
              },
              {
                title: '디바이스상태이력',
                href: '/device/history',
              },
              {
                title: '모뎀관리',
                href: '/device/modem',
              },
              {
                title: '모뎀상태이력',
                href: '/device/mhistory',
              }
            ]
          },
          {
            title: '통계관리',
            href: '/statistics/advertise',
            icon: <AssessmentIcon />,
            submenus: [
              {
                title: '광고재생로그',
                href: '/statistics/advertise',
              },
              {
                title: '택시승하차로그',
                href: '/statistics/taxi',
              },
              {
                title: '광고사별광고현황',
                href: '/statistics/client',
              }
            ]
          },
          {
            title: '정산관리',
            href: '/settlement/agency',
            icon: <ReceiptIcon />,
            submenus: [
              {
                title: '광고대행사별',
                href: '/settlement/agency',
              },
              {
                title: '광고주별',
                href: '/settlement/client',
              },
            ]
          },
          {
            title: 'CMS관리',
            href: '/manage/user',
            icon: <SettingsIcon />,
            submenus: [
              {
                title: '사용자관리',
                href: '/manage/user',
              },
              {
                title: '권역관리',
                href: '/manage/area',
              },
              {
                title: '그룹관리',
                href: '/manage/group',
              },
              {
                title: '광고유효시간',
                href: '/manage/rule',
              }
            ]
          },
        ]
      );
    }
    else {
      if (role === 'agency') {
        setPages(
          [
            {
              title: '정산관리',
              href: '/settlement/agency',
              icon: <ReceiptIcon />,
            },
          ]
        );
      }
      else {
        setPages(
          [
            {
              title: '정산관리',
              href: '/settlement/client',
              icon: <ReceiptIcon />,
            },
          ]
        );
      }
    }
  }, [categories]);

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        {/* {console.log(pages)} */}
        <Profile isDesktop={isDesktop} onClickLogout={onClickLogout}/>
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
          pages={pages}
        />
        {/* <UpgradePlan /> */}
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
  history: PropTypes.object,
  categories: PropTypes.arrayOf(PropTypes.object),
};

Sidebar.defaultProps = {
  categories: [],
};

const mapStateToProps = state => ({
  categories: state.categories.categoriesList,
});

const mapDispatchToProps = dispatch => ({
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar);

//export default Sidebar;
